import { WidgetTable } from '../Widgets';
import { connect } from 'react-redux';
import { getConversionData } from '../../redux/actions/conversion';
import { formatDate } from '../../helpers';
import moment from 'moment-timezone';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetTableConversion',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.conversion.WidgetTableConversion && state.conversion.WidgetTableConversion.data && state.filter.filters.startDate && state.filter.filters.endDate ? state.conversion.WidgetTableConversion.data.map(item => ({
    Date: moment(item.dt).tz(state.filter.filters.tz || 'GMT').format(),
    "# Visits": item.nv,
    "# Unique Visits": item.nvd,
    "# MSISDNs": item.nvm,
    "# Subs": item.ns,
    "% Conversion Rate": `${Math.round((item.ns / item.nv) * 10000) / 100}%`,
    "% MSISDNs": `${Math.round((item.nvm / item.nv) * 10000) / 100}%`
  })) : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.conversion.WidgetTableConversion && state.conversion.WidgetTableConversion.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  loaded: state.conversion.WidgetTableConversion
    && state.conversion.WidgetTableConversion.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  customFilter: true,
  customFilterAcceptedParams: ['pageId', 'os', 'campaignId', 'flowId', 'partnerId'],
  defaultPageSize: ownProps.defaultPageSize ? ownProps.defaultPageSize : 6,
  shouldLoadData: !state.conversion.WidgetTableConversion || (!state.conversion.WidgetTableConversion.loaded && !state.conversion.WidgetTableConversion.loading && !state.conversion.WidgetTableConversion.error),
})

const mapDispatchToProps = { fetchData: getConversionData };

export default connect(mapStateToProps, mapDispatchToProps)(WidgetTable)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetTableConversionConnected.js